import createIcon from '../../createIcon';

/**
 * @component @name CameraOutdoor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTNDMTggMTIuNDUgMTcuNTUgMTIgMTcgMTJIMTNDMTIuNDUgMTIgMTIgMTIuNDUgMTIgMTNWMTdDMTIgMTcuNTUgMTIuNDUgMTggMTMgMThIMTdDMTcuNTUgMTggMTggMTcuNTUgMTggMTdWMTZMMjAgMTcuMDZWMTIuOTRMMTggMTRWMTNaTTEyIDNMNCA5VjIxSDIwVjE5SDZWMTBMMTIgNS41TDE4IDEwVjExSDIwVjlMMTIgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CameraOutdoor = createIcon('CameraOutdoor', [
  [
    'path',
    {
      d: 'M18 13C18 12.45 17.55 12 17 12H13C12.45 12 12 12.45 12 13V17C12 17.55 12.45 18 13 18H17C17.55 18 18 17.55 18 17V16L20 17.06V12.94L18 14V13ZM12 3L4 9V21H20V19H6V10L12 5.5L18 10V11H20V9L12 3Z',
      key: 'kfkuor',
    },
  ],
]);

export default CameraOutdoor;
